import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const SECURITY_QUESTIONS_FORM_FIELD_SCHEMA_FIELD_NAMES = {
  ANSWER1: "answer1",
  ANSWER2: "answer2",
  QUESTION1: "question1",
  QUESTION2: "question2",
};

export const MAX_ANSWER_LENGTH = 20;

export const getSecurityQuestionsFormFieldSchema = () => ({
  answer1: yup
    .string()
    .trim()
    .required()
    .max(MAX_ANSWER_LENGTH)
    .label(i18n("SecurityQuestionsFormField__SECURITY_ANSWER_1").toLowerCase()),
  answer2: yup
    .string()
    .trim()
    .required()
    .max(MAX_ANSWER_LENGTH)
    .label(i18n("SecurityQuestionsFormField__SECURITY_ANSWER_2").toLowerCase()),
  question1: yup
    .string()
    .trim()
    .notOneOf(["Select"], i18n("SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_1"))
    .required(i18n("SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_1")),
  question2: yup
    .string()
    .trim()
    .notOneOf(["Select"], i18n("SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_2"))
    .required(i18n("SecurityQuestionsFormField__SELECT_SECURITY_QUESTION_2")),
});
